// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"172":"1e7e78ce","508":"d2ef93ab","820":"c24790a1"}[chunkId] + ".css";
};